var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 512,
    height: 512,
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6ec1e4"
    },
    cx: 64,
    cy: 64,
    r: 64
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F6073"
    },
    d: "M64,98c-18.748,0-34-15.252-34-34s15.252-34,34-34s34,15.252,34,34S82.748,98,64,98z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2D4452"
    },
    cx: 64,
    cy: 64,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D4452"
    },
    d: "M89,111c-1.104,0-2-0.896-2-2c0-4.963,4.037-9,9-9h1c1.654,0,3-1.346,3-3s-1.346-3-3-3H64    c-1.104,0-2-0.896-2-2s0.896-2,2-2h33c3.859,0,7,3.141,7,7s-3.141,7-7,7h-1c-2.757,0-5,2.243-5,5C91,110.104,90.104,111,89,111z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#233540"
    },
    cx: 64,
    cy: 64,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M64,19c-24.854,0-45,20.146-45,45s20.146,45,45,45s45-20.146,45-45S88.854,19,64,19z     M77.436,36.423c3.904-3.905,10.236-3.905,14.143,0s3.904,10.237,0,14.144c-3.905,3.904-10.237,3.904-14.143,0    C73.529,46.66,73.529,40.328,77.436,36.423z M25,64c0-5.521,4.479-10,10-10s10,4.479,10,10s-4.479,10-10,10S25,69.521,25,64z     M50.564,91.577c-3.904,3.905-10.236,3.905-14.143,0s-3.904-10.237,0-14.142c3.905-3.906,10.237-3.906,14.143,0    C54.471,81.34,54.471,87.672,50.564,91.577z M50.564,50.564c-3.904,3.904-10.236,3.904-14.143,0    c-3.904-3.904-3.904-10.236,0-14.143c3.905-3.906,10.237-3.904,14.143,0C54.471,40.328,54.471,46.66,50.564,50.564z M64,103    c-5.521,0-10-4.479-10-10s4.479-10,10-10s10,4.479,10,10S69.521,103,64,103z M64,45c-5.521,0-10-4.479-10-10s4.479-10,10-10    s10,4.479,10,10S69.521,45,64,45z M91.577,91.577c-3.905,3.905-10.237,3.905-14.144,0c-3.904-3.905-3.904-10.237,0-14.142    c3.905-3.906,10.237-3.906,14.144,0C95.482,81.34,95.482,87.672,91.577,91.577z M93,74c-5.521,0-10-4.479-10-10s4.479-10,10-10    s10,4.479,10,10S98.521,74,93,74z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.184005ac6de91c0b611a3472c291067c.svg";
export { ForwardRef as ReactComponent };